import { CardSvg } from '@/play/cardSvg'

/** Home card art: a child's painting in a gold frame on a pale wall. */
export function FramesCardArt() {
  return (
    <CardSvg bg="#eeeae2">
      {(id) => (
        <>
          <defs>
            <linearGradient id={id('gold')} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#fff0b8" />
              <stop offset="0.45" stopColor="#d9a63c" />
              <stop offset="1" stopColor="#8a5a14" />
            </linearGradient>
          </defs>
          <rect x="76" y="32" width="180" height="148" rx="6" fill="#cfc8ba" opacity="0.6" />
          <rect x="70" y="26" width="180" height="148" rx="6" fill={`url(#${id('gold')})`} />
          <rect x="94" y="48" width="132" height="104" fill="#fbfaf5" />
          <path d="M94 152 V 128 Q 160 104 226 130 V 152 Z" fill="#3bb273" />
          {['#e63946', '#ff8c1a', '#ffd60a', '#3bb273', '#2f7fd8'].map((c, i) => (
            <path key={c} d={`M${112 + i * 7} 128 A ${48 - i * 7} ${50 - i * 7} 0 0 1 ${208 - i * 7} 128`} fill="none" stroke={c} strokeWidth="6" strokeLinecap="round" />
          ))}
          <circle cx="112" cy="66" r="10" fill="#ffd60a" />
        </>
      )}
    </CardSvg>
  )
}
